export const styles = {
    displayCardHeader: {
        backgroundColor: "#1a3328",
        color: "#ffffff",
        borderRadius: "10px 10px 0 0",
        padding: "0.85rem 1.25rem",
    },
    card: {
        borderRadius: 10,
        overflow: "hidden",
        border: "1.5px solid #c6deca",
        boxShadow: "0 2px 10px rgba(20,50,30,0.06)",
    },
    label: {
        display: "block",
        fontSize: "0.75rem",
        fontWeight: 700,
        color: "#5a6e61",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginBottom: 4,
    },
    select: {
        width: "100%",
        height: 38,
        marginBottom: "1.25rem",
        borderRadius: 7,
        border: "1.5px solid #c6deca",
        padding: "0 0.65rem",
        fontSize: "0.88rem",
        color: "#1a2e22",
        backgroundColor: "#ffffff",
    },
    textarea: {
        width: "100%",
        borderRadius: 7,
        border: "1.5px solid #c6deca",
        padding: "0.6rem 0.75rem",
        fontSize: "0.88rem",
        color: "#1a2e22",
        backgroundColor: "#ffffff",
        marginBottom: "1.25rem",
    },
    errorStyle: {
        color: "#c62828",
        fontSize: "0.75rem",
    },
};
